import lf from "localforage";

import APIFunction from "../service-workers/common";

const lf_data_image_upload = lf.createInstance({name: "wip_image_upload_data"});
const lf_data_image_files = lf.createInstance({name: "wip_image_upload_files"});

// console.clear();
// console.log("new file upload module 1.0.0.5");

export default async () => {
	programcount++;
	waitcount = 0;
	// console.log("Upload File Called", programcount);
	let checkForNextFile = true;
	while (checkForNextFile) {
		await UpdateAnyFileFields();

		// console.log("Done with File Fields. Checking Files now");

		let imgQ = await lf_data_image_files.getItem("imgQ");

		if (!imgQ || imgQ.length <= 0) checkForNextFile = false;

		// console.log({imgQ});

		if (checkForNextFile) {
			let fileIDToUpload = imgQ[0];
			// console.log("found file to upload", fileIDToUpload);

			let img = await lf_data_image_files.getItem(fileIDToUpload);

			if (img) {
				// console.log("uploading img");

				let success = await UploadFileToServer(img);

				// await Wait(30000);
				//on success
				//verify upload

				if (success) await RemoveFirstFileFromLF(fileIDToUpload);
			} else {
				await RemoveFirstFileFromLF(fileIDToUpload);
			}
		} else {
			// console.log("Done. All uploaded");
			await RepairQueue(lf_data_image_upload, "queue");
			await RepairQueue(lf_data_image_files, "imgQ");
		}
	}
};

async function RepairQueue(store, qkey) {
	let listOfFiles = await store.keys();
	let queue = await store.getItem(qkey);

	if (listOfFiles) {
		if (!queue) queue = [];
		listOfFiles = listOfFiles.filter((f) => {
			return f != qkey && !queue.some((s) => s == f) && f != "count";
		});
		// console.log({qkey, queue, listOfFiles});
		if (listOfFiles.length > 0) {
			queue = [...queue, ...listOfFiles];
			// console.log({revisedq: queue});
			await store.setItem(qkey, queue);
		}
	}
}

async function UploadFileToServer(img) {
	let res = await fetch(img.url);
	let blob = await res.blob();

	var body = new FormData();
	body.append("myfile", blob, img.caption);

	let response = await fetch(`/file/upload?nf=${img.nf}&uuid=${img.uuid}`, {
		method: "POST",
		body: body,
	});

	let result = await response.json();
	return result.success;
}

async function RemoveFirstFileFromLF(fileID) {
	let queue = await lf_data_image_files.getItem("imgQ");
	if (!queue) return;
	if (queue.length <= 0) return;
	if (queue[0] == fileID || !fileID) queue.splice(0, 1);
	await lf_data_image_files.setItem("imgQ", queue);
	await lf_data_image_files.removeItem(fileID);
	lf_data_image_files.getItem("count").then((c) => {
		if (!c) c = 0;
		c -= 1;
		if (c < 0) c = 0;
		lf_data_image_files.setItem("count", c);
	});
}

let waitcount = 0;
let programcount = 0;

async function Wait(t) {
	return new Promise((res) => {
		setTimeout(() => {
			waitcount++;
			// console.log("waiting", waitcount);
			res();
		}, t);
	});
}

async function UpdateAnyFileFields() {
	let checkForNextQT = true;
	while (checkForNextQT) {
		// console.log("checking for next qt");
		// await Wait(30000);
		let nextQToWorkOn = await GetFirstQueueItem();

		if (!nextQToWorkOn) {
			// console.log("no new qt");
			checkForNextQT = false;
		} else {
			// console.log("found file", {nextQToWorkOn});
			let {nf, imgs, finalFileFieldValue, finalFileFieldUpdated} = await lf_data_image_upload.getItem(nextQToWorkOn);

			// console.log({nf, imgs, finalFileFieldValue, finalFileFieldUpdated});

			if (!finalFileFieldValue) {
				finalFileFieldValue = await GetFinalValueForFileField(imgs);
				// console.log(finalFileFieldValue);
				await lf_data_image_upload.setItem(nextQToWorkOn, {nf, imgs, finalFileFieldValue});
			}

			if (!finalFileFieldUpdated) {
				// console.log("updating final field value");
				let r = await APIAction("UpdateValueForNF", {nf, value: finalFileFieldValue, directsave: true, append: true});
				let result = JSON.parse(r.d);
				// console.log("updated nf", {r, result});

				// await Wait(10000);
				if (result.success)
					await lf_data_image_upload.setItem(nextQToWorkOn, {
						nf,
						imgs,
						finalFileFieldValue,
						finalFileFieldUpdated: true,
					});
			}

			if (finalFileFieldUpdated) {
				await SetupUploadQueue(imgs);
				await RemoveFirstQueueItem(nextQToWorkOn);
			}
		}
	}

	// console.log("done checking for next qt");
}

async function SetupUploadQueue(imgs) {
	imgs
		.filter((img) => !!img.new)
		.forEach(async (img) => {
			await lf_data_image_files.setItem(img.uuid, img);
		});

	lf_data_image_files.getItem("imgQ", (queue) => {
		if (!queue) queue = [];
		imgs
			.filter((img) => !!img.new)
			.forEach((img) => {
				queue.push(img.uuid);
			});
		lf_data_image_files.setItem("imgQ", queue);
	});
}

async function GetFirstQueueItem() {
	let queue = await lf_data_image_upload.getItem("queue");

	if (!queue) return;
	if (queue.length <= 0) return;
	return queue[0];
}

async function RemoveFirstQueueItem(QT) {
	// console.log("removing qt", QT);
	let queue = await lf_data_image_upload.getItem("queue");

	if (!queue) return;
	if (queue.length <= 0) return;
	if (queue[0] == QT || !QT) queue.splice(0, 1);
	await lf_data_image_upload.setItem("queue", queue);
	await lf_data_image_upload.removeItem(QT);
}

async function GetFinalValueForFileField(imgs) {
	let previewURL = "https://s3.ap-southeast-1.amazonaws.com/files.prasora.com/prasora/uploading.jpg";
	imgs = (imgs || [])
		.filter((i) => !!i.url)
		.map((i) => {
			if (i.new) return `${previewURL}?id=${i.uuid}&filename=${i.caption}`;
			return i.url;
		});
	let newURL = imgs.join(",");
	// console.log({newURL});
	return newURL;
}

async function APIAction(url, data) {
	return new Promise((resolve) => {
		APIFunction(url, data)
			.then((r) => {
				resolve(r);
			})
			.catch((e) => {
				console.log(e);
			});
	});
}

function addQueryParamsToUrl(url, params) {
	// if URL is relative, we'll need to add a fake base
	var fakeBase = !url.startsWith("http") ? "http://fake-base.com" : undefined;
	var modifiedUrl = new URL(url || "", fakeBase);

	// add/update params
	Object.keys(params).forEach(function (key) {
		if (modifiedUrl.searchParams.has(key)) {
			modifiedUrl.searchParams.set(key, params[key]);
		} else {
			modifiedUrl.searchParams.append(key, params[key]);
		}
	});

	// return as string (remove fake base if present)
	return modifiedUrl.toString().replace(fakeBase, "");
}
